import { FronteggContext } from '@frontegg/rest-api';
import { Axios } from 'src/lib';
import {
  addPractitionerSettingsConfig,
  createSettingsConfig,
  getSettingsConfig,
  listSettingsPractitionersConfig,
  organizationTimeConfig,
  getV3SettingsConfig,
} from 'src/lib/requests/settings.url';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';
import {
  getConditionByAppointmentTypeSlice,
  getPractitionerPreferencesSlice,
} from '../slices/appointments.slice';
import {
  getSettingsNotificationsSlice,
  listPractitionerNamesSlice,
  getTimezoneSlice,
  getTimezoneLoadingSlice,
  getV3NotificationsDetailsSlice,
  reportsListSlice,
  reportsListLoadingSlice,
  downloadableReportUrlSlice,
} from '../slices/settings.slice';
import { getAllPractitionersNames } from './appointment.action';

export const createSettingsAction = ({ payload }) => {
  return async (dispatch) => {
    try {
      const { url } = createSettingsConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, payload, { headers });
      if (result?.status === 200) {
        showToastSuccess('Notification settings saved');
        const payload = {
          is_new_appointment: false,
        };
        dispatch(getAllPractitionersNames(payload));
      }
    } catch (e) {
      showToastError('Notification settings not saved');
    }
  };
};

export const getSettingsNotifications = (body) => {
  return async (dispatch) => {
    try {
      const { url } = getSettingsConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, body, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getSettingsNotificationsSlice(response));
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const getV3NotificationsDetailsAction = ({
  service_request_type_id,
}) => {
  return async (dispatch) => {
    try {
      const { url } = getV3SettingsConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.get(url, {
        headers,
        params: {
          service_request_type_id,
        },
      });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getV3NotificationsDetailsSlice(response));
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const createV3SettingsAction = ({ payload }) => {
  return async (dispatch) => {
    try {
      const { url } = getV3SettingsConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, payload, { headers });
      if (result?.status === 200) {
        showToastSuccess('Notification settings saved');
      }
    } catch (e) {
      showToastError('Notification settings not saved');
    }
  };
};

export const listSettingsPractitionersAction = () => {
  return async (dispatch) => {
    try {
      const { url } = listSettingsPractitionersConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data?.practitioners_data;
      if (result?.status === 200) {
        dispatch(listPractitionerNamesSlice(response));
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const addPractitionerSettings = (payload) => {
  return async () => {
    try {
      const { url } = addPractitionerSettingsConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, payload, { headers });
      if (result?.status === 200) {
        showToastSuccess('Saved');
      }
    } catch {
      showToastError('Error occurred');
    }
  };
};

export const createOrganizationTime = (payload) => {
  return async () => {
    try {
      const { url } = organizationTimeConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, payload, { headers });
      if (result?.status === 200) {
        showToastSuccess('Organization settings saved');
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getOrgSetting = (org_uuid) => {
  return async () => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(`/organization_setting`, { headers });
      if (result?.status === 200) {
        const setting = result?.data?.setting ?? {};
        return setting;
      }
    } catch {
      showToastError('Error occurred');
      return {};
    }
  };
};

export const setBulkCSVUploadSetting = (org_uuid, payload) => {
  return async () => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const result = await Axios.put(`/organization_setting`, payload, {
        headers,
      });
      if (result?.status === 200) {
        showToastSuccess(
          `CSV bulk uploads ${payload?.settings?.enable_bulk_appointment_upload ? 'enabled' : 'disabled'}`
        );
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getDacSettingsEnabled = () => {
  return async () => {
    const token = FronteggContext.getAccessToken();
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    };

    const result = await Axios.get(`/v2/dac/enabled`, { headers });

    if (result?.status === 200) {
      return result?.data?.enabled;
    } else {
      return false;
    }
  };
};

export const getTimezone = () => {
  return async (dispatch) => {
    try {
      dispatch(getTimezoneLoadingSlice(true));
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };

      const result = await Axios.get(`/v2/organization/timezone`, { headers });
      if (result?.status === 200) {
        dispatch(getTimezoneSlice(result?.data?.timezone));
      }
    } catch (error) {
      if (error?.response?.status === 404) {
        dispatch(getTimezoneSlice(null));
      }
      console.log(error);
    } finally {
      dispatch(getTimezoneLoadingSlice(false));
    }
  };
};

export const postTimezone = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(getTimezoneLoadingSlice(true));
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };

      const result = await Axios.post(`/v2/organization/timezone`, payload, {
        headers,
      });
      if (result?.status === 201) {
        showToastSuccess('Timezone added');
        dispatch(getTimezone());
      }
    } catch (error) {
      showToastError('Error occurred');
      console.log(error);
    } finally {
      dispatch(getTimezoneLoadingSlice(false));
    }
  };
};

export const updateTimezone = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(getTimezoneLoadingSlice(true));
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };

      const result = await Axios.put(`/v2/organization/timezone`, payload, {
        headers,
      });
      if (result?.status === 200) {
        showToastSuccess('Timezone updated');
        dispatch(getTimezone());
      }
    } catch (error) {
      showToastError('Error occurred');
      console.log(error);
    } finally {
      dispatch(getTimezoneLoadingSlice(false));
    }
  };
};

export const createAppointmentReport = (payload) => {
  return async () => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };

      const result = await Axios.post(`/v2/reports`, payload, {
        headers,
      });
      if (result?.status === 202) {
        showToastSuccess(
          'Report creation started. Please check back in few minutes.'
        );
      }
    } catch (error) {
      showToastError('Error occurred while creating report');
      console.log(error);
    }
  };
};

export const getReportsList = () => {
  return async (dispatch) => {
    try {
      dispatch(reportsListLoadingSlice(true));
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };

      const result = await Axios.get(`/v2/reports`, {
        headers,
      });
      if (result?.status === 200) {
        dispatch(reportsListSlice(result?.data?.s3_objects));
      }
    } catch (error) {
      showToastError('Error occurred while fetching reports');
      console.log(error);
    } finally {
      dispatch(reportsListLoadingSlice(false));
    }
  };
};

export const downloadAppointmentReport = (s3_key) => {
  return async (dispatch) => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };

      const result = await Axios.post(
        `/v2/reports/download`,
        { s3_key },
        {
          headers,
        }
      );
      if (result?.status === 200) {
        dispatch(downloadableReportUrlSlice(result?.data?.download_url));
      }
    } catch (error) {
      showToastError('Error occurred while downloading report');
      console.log(error);
    }
  };
};
